var _path, _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg4Benefiticon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 69,
    viewBox: "0 0 69 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.6194 23.6193C20.6667 25.5719 20.6667 28.7146 20.6667 35C20.6667 41.2854 20.6667 44.4281 22.6194 46.3807C24.572 48.3334 27.7147 48.3334 34.0001 48.3334C40.2855 48.3334 43.4282 48.3334 45.3808 46.3807C47.3334 44.4281 47.3334 41.2854 47.3334 35C47.3334 28.7146 47.3334 25.5719 45.3808 23.6193C43.4282 21.6667 40.2855 21.6667 34.0001 21.6667C27.7147 21.6667 24.572 21.6667 22.6194 23.6193ZM40.6667 30C41.219 30 41.6667 30.4477 41.6667 31V43C41.6667 43.5523 41.219 44 40.6667 44C40.1145 44 39.6667 43.5523 39.6667 43V31C39.6667 30.4477 40.1145 30 40.6667 30ZM35.0001 35C35.0001 34.4477 34.5524 34 34.0001 34C33.4478 34 33.0001 34.4477 33.0001 35V43C33.0001 43.5523 33.4478 44 34.0001 44C34.5524 44 35.0001 43.5523 35.0001 43V35ZM27.3334 38C27.8857 38 28.3334 38.4477 28.3334 39V43C28.3334 43.5523 27.8857 44 27.3334 44C26.7811 44 26.3334 43.5523 26.3334 43V39C26.3334 38.4477 26.7811 38 27.3334 38Z",
    fill: "#7957FF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.5,
    y: 5.5,
    width: 58,
    height: 58,
    rx: 15.5,
    stroke: "url(#paint0_linear_27_1854)",
    strokeOpacity: 0.3,
    strokeWidth: 11
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_27_1854",
    x1: 34.5,
    y1: 0,
    x2: 34.5,
    y2: 69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg4Benefiticon);
export default __webpack_public_path__ + "static/media/4 benefit icon.9e554c31106c1df9e47fdb99d8c8612b.svg";
export { ForwardRef as ReactComponent };